import store from '@/store';
import { updateCrumbs as createUpdateCrumbs, resetCrumbs as createResetCrumbs } from '@/store/bread-crumbs';
import {
  hideBreadCrumbs as innerHideBreadCrumbs,
  showBreadCrumbs as innerShowBreadCrumbs,
} from '@/store/bread-crumbs-info';

export const updateCrumbs = (data) => {
  store.dispatch(createUpdateCrumbs(data));
  return resetCrumbs;
};

export const resetCrumbs = () => store.dispatch(createResetCrumbs());

export const hideBreadCrumbs = () => {
  store.dispatch(innerHideBreadCrumbs());
};

export const showBreadCrumbs = () => {
  store.dispatch(innerShowBreadCrumbs());
};
